// packages/core/src/rewards/RewardMath.ts
// ─────────────────────────────────────────────────────────────────────────
// Pure level math for the reward system. Thin surface over the existing
// gamification level logic so the dispatcher + XP slice import level math
// from ONE place — and so banded labels can later be swapped in here.
//
// NOTE: This intentionally does NOT re-export getLevelInfo / levelLabel /
// LevelInfo. Those already live in srs/gamification and are exported via the
// `srs` subpackage; re-exporting them here would collide at the root barrel
// (export * from both ./srs and ./rewards). Consumers that want the raw level
// helpers import them from '@nisk/core/srs'. The reward system exposes
// levelSnapshot() instead.
// ─────────────────────────────────────────────────────────────────────────

import { getLevelInfo, levelLabel } from '../srs/gamification';

/** Full level snapshot for a given total XP. Used to hydrate the XP slice. */
export interface LevelSnapshot {
	totalXp: number;
	level: number;
	levelLabel: string;
	xpIntoLevel: number;
	xpForNextLevel: number;
	progressPct: number;
}

export function levelSnapshot(totalXp: number): LevelSnapshot {
	const info = getLevelInfo(totalXp);
	return {
		totalXp,
		level: info.level,
		levelLabel: levelLabel(info.level),
		xpIntoLevel: info.xpIntoLevel,
		xpForNextLevel: info.xpNeeded,
		progressPct: info.progressPct,
	};
}
